import React from "react";

const VALUE_PROPS = [
  {
    title: "Easy",
    description: "Donate quickly and easily",
    icon: process.env.PUBLIC_URL + "/main/fly.png",
  },
  {
    title: "Powerful",
    description: "Send help right to the people and causes you care about",
    icon: process.env.PUBLIC_URL + "/main/flower.png",
  },
  {
    title: "Trusted",
    description: (
      <>Your donation is protected by the HeartLink Giving Guarantee</>
    ),
    icon: process.env.PUBLIC_URL + "/main/dun.svg",
  },
];

const ValuePropsSection = () => (
  <section className="value-props">
    <div className="value-props__inner">
      <h2 className="value-props__title">
        Your easy, powerful, and trusted home for help
      </h2>
      <div className="value-props__grid">
        {VALUE_PROPS.map((item, i) => (
          <article className="value-props__item" key={`${item.title}-${i}`}>
            <div className="value-props__icon" aria-hidden="true">
              <img alt="" src={item.icon} />
            </div>
            <div>
              <div className="value-props__item-title">{item.title}</div>
              <p className="value-props__item-desc">{item.description}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ValuePropsSection;
